export default __webpack_public_path__ + "static/media/attachFile.1d831df3.svg";